import React from 'react'

import { reminderStatusLabel, reminderStatusTone } from './taskReminders'

const TONES = {
  info: 'bg-info-light text-info-main',
  success: 'bg-success-light text-success-main',
  warning: 'bg-warning-light text-warning-main',
  error: 'bg-error-light text-error-main',
  neutral: 'bg-[var(--color-gray-100)] dark:bg-white/[0.06] text-text-secondary',
}

const TaskChip = ({ tone = 'neutral', children }) => (
  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${TONES[tone]}`}>
    {children}
  </span>
)

export const ReminderStatusChip = ({ status }) => (
  <TaskChip tone={reminderStatusTone(status)}>{reminderStatusLabel(status)}</TaskChip>
)

export default TaskChip
